module.exports = __webpack_public_path__ + "img/powerpay.2f4c00ea.svg";